
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";

export interface ClientPayment {
  id: string;
  clientId: string;
  amount: number;
  paymentDate: string;
  notes?: string;
  organizationId: string;
  createdAt: string;
  createdBy?: string;
  updatedAt: string;
  session_consumption_id?: string | null;
  session_booking_date?: string | null;
  session_workout_name?: string | null;
  subscription_id?: string | null;
  subscription_workout_type_name?: string | null;
}

export const useClientPaymentHistory = (clientId: string) => {
  const { currentOrganization } = useAuth();
  
  return useQuery({
    queryKey: ['clientPayments', clientId, currentOrganization?.id],
    queryFn: async (): Promise<ClientPayment[]> => {
      console.log('Fetching payment history for client:', clientId, 'in organization:', currentOrganization?.id);
      
      if (!currentOrganization?.id) {
        console.log('No current organization, returning empty array');
        return [];
      }
      
      // Use the fixed RPC function
      const { data: paymentsData, error: paymentsError } = await supabase
        .rpc('get_client_payments', { p_client_id: clientId });

      if (paymentsError) {
        console.error('Error fetching client payments:', paymentsError);
        throw paymentsError;
      }

      console.log('Raw payments data:', paymentsData);

      if (!paymentsData || !Array.isArray(paymentsData)) {
        return [];
      }

      return paymentsData.map((payment: any) => ({
        id: payment.id,
        clientId: payment.client_id,
        amount: payment.amount,
        paymentDate: payment.payment_date,
        notes: payment.notes,
        organizationId: payment.organization_id,
        createdAt: payment.created_at,
        createdBy: payment.created_by,
        updatedAt: payment.updated_at,
        session_consumption_id: payment.session_consumption_id,
        session_booking_date: payment.session_booking_date,
        session_workout_name: payment.session_workout_name,
        subscription_id: payment.subscription_id,
        subscription_workout_type_name: payment.subscription_workout_type_name,
      }));
    },
    enabled: !!clientId && !!currentOrganization?.id,
  });
};
